import React, { useState, useContext } from 'react';
import { FiUpload } from 'react-icons/fi';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import NotificationsActions from '~redux/notifications';
import { UserContext } from '~contexts/user';

import PhotoUpload from '~components/photo-upload';

const Photo = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { user, updateCustomer, updateWorker, uploadUserPicture, deleteUserPicture } = useContext(UserContext);
  const { profilePicture, firstName, accountType, personId } = user;

  const [isUploading, setIsUploading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);

  const deleteImage = async () => {
    setIsUploading(true);
    try {
      await deleteUserPicture(personId);
      const newUser = { ...user, profilePicture: '' };
      if (accountType === 'worker') {
        await updateWorker(newUser);
      } else {
        await updateCustomer(newUser);
      }
      setIsUploaded(true);
    } catch (err) {
      console.log('Error while deleting picture', err);
      dispatch(NotificationsActions.addNotification('Error while deleting photo'));
    } finally {
      setIsUploading(false);
    }
  };

  const uploadImage = async (img) => {
    setIsUploading(true);
    if (!img) {
      await deleteImage();
      setIsUploading(false);
      setIsUploaded(true);
      return;
    }

    try {
      const userPicture = await uploadUserPicture(img, personId);
      if (accountType === 'worker') {
        await updateWorker({
          ...user,
          profilePicture: JSON.stringify(userPicture),
        });
      } else {
        await updateCustomer({
          ...user,
          profilePicture: JSON.stringify(userPicture),
        });
      }
      setIsUploaded(true);
    } catch (err) {
      console.log('Error while uploading picture', err);
      dispatch(NotificationsActions.addNotification('Error while uploading photo'));
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <PhotoUpload.Wrapper
      onChange={(img) => {
        uploadImage(img);
      }}
      defaultImage={
        !profilePicture
          ? null
          : `${profilePicture?.large}${profilePicture?.updatedAt ? `?${profilePicture.updatedAt}` : ''}`
      }
      updatedAt={profilePicture?.updatedAt}
      firstName={firstName}
      className="c-box__header"
      isUploaded={isUploaded}
      isUploading={isUploading}
      onStartSelect={() => setIsUploaded(false)}
    >
      <PhotoUpload.Preview className="c-box__photo" />
      <PhotoUpload.Content>
        <h3 className="l-headline--secondary">{firstName || '-'}</h3>

        <div className="c-box__photo-buttons">
          <PhotoUpload.Button className="c-btn-text" disabled={isUploading}>
            <FiUpload />
            <span>
              {intl.formatMessage({
                id: 'containers.account.personal-data.update-photo',
                defaultMessage: 'Update photo',
              })}
            </span>
          </PhotoUpload.Button>
        </div>
      </PhotoUpload.Content>
    </PhotoUpload.Wrapper>
  );
};

export default Photo;
